export default "__VITE_ASSET__qOHOrvgQ__"